const round2 = (n) => Math.round(Number(n) * 100) / 100

/**
 * Hotel booking price breakdown from persisted paymentBreakdown, hotelTotals, or cart snapshot.
 */
export function getHotelBookingPriceBreakdown(booking) {
  const cartItem = booking?.bookingData?.originalCartItem || {}
  const pb = booking?.bookingData?.paymentBreakdown || null
  const ht = booking?.generalBackupMetadata?.hotelTotals || null

  const currency = pb?.currency || ht?.currencyCode || cartItem?.currency || 'USD'
  const baseAmount = round2(Number(pb?.base ?? ht?.subtotal ?? cartItem?.priceDetails?.baseRate ?? 0))
  const hotelTax = round2(
    Number(pb?.hotelTax ?? ht?.taxes ?? cartItem?.priceDetails?.tax ?? cartItem?.totalTaxesAndFees ?? 0)
  )
  const markupAmount = round2(Number(pb?.markupAddOn ?? cartItem?.agentCommission?.markupAmount ?? 0))

  let stripeFees = round2(
    Number(
      pb?.stripeProcessingFees ??
        ht?.stripeProcessingFees ??
        cartItem?.processingFees?.totalProcessingFees ??
        cartItem?.priceDetails?.additionalFees ??
        0
    )
  )

  const totalPayable = round2(
    Number(
      pb?.totalPayable ??
        booking?.generalBackupMetadata?.finalAmount ??
        ht?.total ??
        cartItem?.totalWithProcessingFees ??
        cartItem?.price ??
        0
    )
  )

  if (stripeFees <= 0 && totalPayable > 0) {
    const derived = round2(totalPayable - baseAmount - hotelTax - markupAmount)
    if (derived > 0.02) stripeFees = derived
  }

  const taxAndFees = round2(hotelTax + stripeFees)

  return {
    currency,
    baseAmount,
    hotelTax,
    stripeFees,
    taxAndFees,
    markupAmount,
    totalPayable
  }
}
